var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"card p-0"},[_c('b-row',_vm._l((_vm.rows),function(col,index){return _c('b-col',{key:index,class:'ncols-' + _vm.actualNCols,attrs:{"cols":"6","md":_vm.cols}},[_c('DataCard',{attrs:{"data":col}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }